import React from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import FooterColumn from './footer-column'
import './footer.css'

const Footer = (props) => {
  return (
    <div id={props.footerId} className="footer-container1">
      <footer className="footer-section">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-thq-footer-column-elm footer-contact-col footer-column">
              <h2 className="section-subtitle footer-title">Payment Options</h2>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg height="24" width="24" viewBox="0 0 24 24">
                      <g fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M3 20.4V3.6a.6.6 0 0 1 .6-.6h16.8a.6.6 0 0 1 .6.6v16.8a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6Z"></path>
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 8.5c-.685-.685-1.891-1.161-3-1.191M9 15c.644.86 1.843 1.35 3 1.391m0-9.082c-1.32-.036-2.5.561-2.5 2.191c0 3 5.5 1.5 5.5 4.5c0 1.711-1.464 2.446-3 2.391m0-9.082V5.5m0 10.891V18.5"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <a href="tel:+1234567890">
                      <div className="footer-contact-link">
                        <span>Zelle</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg height="24" width="24" viewBox="0 0 32 32">
                      <path
                        fill="currentColor"
                        d="M26 2h4v4h-4zm0 6h4v4h-4zm-6-6h4v4h-4zm0 6h4v4h-4zm8 12H14v2h2v4h-2v2h9v-2h-5v-4h10a2 2 0 0 0 2-2v-6h-2zM6 6h12V4H6a2 2 0 0 0-2 2v6h2zm4 8H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2m0 14H4V16h6z"
                      ></path>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <a href="mailto:info@schedlerserve.com?subject=">
                      <div className="footer-contact-link">
                        <span>Cash App</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg height="24" width="24" viewBox="0 0 24 24">
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path
                          strokeLinecap="round"
                          d="M14.5 8.5c-.78-.202-1.866-.5-2.735-.5C7.476 8 4 10.668 4 13.958c0 1.891 1.148 3.577 2.938 4.668l-.485 1.6a.6.6 0 0 0 .574.774h1.764a.6.6 0 0 0 .36-.12l1.395-1.047h2.437l1.395 1.047a.6.6 0 0 0 .36.12h1.764a.6.6 0 0 0 .574-.774l-.485-1.6c1.067-.65 1.905-1.511 2.409-2.501M14.5 8.5L19 7l-.084 3.628L21 11.5V15l-1.926 1"
                        ></path>
                        <path
                          fill="currentColor"
                          strokeLinecap="round"
                          d="M15.5 13a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1"
                        ></path>
                        <path strokeLinecap="round" d="M2 10s0 2.4 2 3"></path>
                        <path d="M12.8 7.753c.13-.372.2-.772.2-1.188C13 4.596 11.433 3 9.5 3S6 4.596 6 6.565c0 .941.358 1.798.944 2.435"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <a href="mailto:info@schedlerserve.com?subject=">
                      <div className="footer-contact-link">
                        <span>Venmo</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg height="24" width="24" viewBox="0 0 24 24">
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M3 17.5L6 3h7c6 0 6 9 0 9H8.7l-1.2 5.5z"></path>
                        <path d="m6.8 21l3-14.5h7c6 0 6 9 0 9h-4.3L11.3 21z"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <span className="footer-contact-value">Paypal</span>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-icon-wrapper">
                    <svg height="24" width="24" viewBox="0 0 24 24">
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      >
                        <path d="M22 9v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zm0 0H6"></path>
                        <path d="M16.5 13.382a1.5 1.5 0 1 1 0 2.236m0-2.236a1.5 1.5 0 1 0 0 2.236"></path>
                      </g>
                    </svg>
                  </div>
                  <div className="footer-contact-text">
                    <span className="footer-contact-value">
                      Online Payment via Serve Manager
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <FooterColumn></FooterColumn>
          </div>
          <div className="footer-bottom footer-thq-footer-bottom-elm">
            <div className="footer-container2">
              <div className="footer-container3">
                <p className="footer-copyright section-content footer-thq-footer-copyright-elm1">
                  <span>
                    KS Process Service, Inc.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span>
                    All Rights Reserved.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </p>
              </div>
              <p className="footer-copyright section-content">
                2221 Justin Rd, #119-328, Flower Mound, TX 75028
              </p>
            </div>
            <div className="footer-accreditation">
              <span className="footer-accreditation-text">
                Member of Texas Process Server Association
              </span>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<script defer data-name="footer-logic">
(function(){
  const yearSpan = document.getElementById("current-year")
  if (yearSpan) {
    yearSpan.textContent = new Date().getFullYear()
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Footer.defaultProps = {
  footerId: '',
}

Footer.propTypes = {
  footerId: PropTypes.string,
}

export default Footer
